import $ from 'jquery'
import _ from 'underscore'
import TemplateView from '../../../TemplateView'
import Month from './month/Month'
import {geSelectedYear, getCorporateDaysForSelectedYear, getDefaultWorkSchedule} from '../selectors'
import {addCorporateDay, deleteCorporateDay} from '../actions'
import {connect} from '../../../redux/utils'
import {dayStatuses, WORK_SCHEDULE_YEAR_START} from '../constants'
import {bindActionCreators} from 'redux'
import CorporateHolidayEditor from './month/CorporateHolidayEditor'
import messageResource from '../../../messageResource'
import RegularNonWorkingDayEditor from './month/RegularNonworkingDayEditor'
import SimpleDiv from '../../../components/SimpleDiv'
import {canManageSystemSettings} from '../../../loggedInUser/selectors'

class Calendar extends TemplateView {
    constructor({
        addCorporateDay = () => {},
        deleteCorporateDay = () => {},
    }) {
        super()

        this.actions = {
            addCorporateDay,
            deleteCorporateDay,
        }

        this.state = {
            defaultWorkSchedules: [],
            corporateDays: {},
            selectedYear: WORK_SCHEDULE_YEAR_START,
            canManage: false,
        }

        this.months = {}

        this.onAnyStatePropertyChanged(['defaultWorkSchedules', 'selectedYear', 'canManage'], () => this.updateCalendar())

        this.onStatePropertyChanged('corporateDays', () => {
            if (_.size(this.months) > 0) {
                for (let i = 0; i < 12; i++) {
                    let monthDate = new Date(this.state.selectedYear, i)
                    let corporateDays = {}
                    if (this.state.corporateDays) {
                        corporateDays = this.state.corporateDays[i] || {}
                    }
                    this.months[monthDate].setState({
                        corporateDays: corporateDays
                    })
                }
            }
        })
    }

    templateHtml() {
        return '<div class="monthsContainer">' +
               '</div>'
    }

    afterRender() {
        this.updateCalendar()
    }

    updateCalendar() {
        this.getEl().empty()
        let currentDate = window.currentUserTime()
        currentDate.clearTime()

        if (this.state.defaultWorkSchedules.length > 0) {
            for (let i = 0; i < 12; i++) {
                let monthDate = new Date(this.state.selectedYear, i)

                let month = new Month({
                    firstMonthDate: monthDate.getFirstDateOfMonth(),
                    weekStartDay: SystemSettings.weekStartDay,
                    defaultWorkSchedules: this.state.defaultWorkSchedules,
                    currentDate: currentDate,
                    editable: this.state.canManage,
                    onDayClick: (dayEl, date, nonWorking, status, title) => this.handleDayClick(dayEl, date, nonWorking, status, title),

                }).init(this.getEl())

                let corporateDays = {}

                if (this.state.corporateDays) {
                    corporateDays = this.state.corporateDays[i] || {}
                }
                month.setState({
                    corporateDays: corporateDays
                })

                this.months[monthDate] = month
            }
        }

        //add empty month elements for proper positioning
        for (let n = 0; n < 4; n++) {
            new SimpleDiv({
                additionalClass: 'components_month emptyMonth',
            }).init(this.getEl())
        }

        const $body = $('body')
        this.corporateHolidayEditor = new CorporateHolidayEditor({
            editCallback: (date, isWorking, title) => this.actions.addCorporateDay(date, isWorking, title),
            deleteCallback: (date) => this.actions.deleteCorporateDay(date),
        }).init($body)

        this.regularNonworkingDayEditor = new RegularNonWorkingDayEditor({
            editCallback: (date, isWorking, title) => this.actions.addCorporateDay(date, isWorking, title),
            deleteCallback: (date) => this.actions.deleteCorporateDay(date),
        }).init($body)
    }


    handleDayClick(dayEl, date, nonWorking, status, title = '') {
        if (!nonWorking && status === dayStatuses.STANDARD_DAY) {
            this.actions.addCorporateDay(date, false, messageResource.getMessage('work_schedule.corporate_holiday'))
        } else if (status === dayStatuses.CORPORATE_HOLIDAY) {
            this.corporateHolidayEditor.setState({
                date,
                title,
                showMarkAsWorkingButton: nonWorking,
            })
            this._openEditor(this.corporateHolidayEditor, dayEl)
        } else if (nonWorking) {
            this.regularNonworkingDayEditor.setState({
                date,
                nonStandardWorking: status === dayStatuses.NON_STANDARD_WORKING_DAY,
            })
            this._openEditor(this.regularNonworkingDayEditor, dayEl)
        }
    }

    _openEditor(editor, dayEl) {
        editor.setOnHideCallback(() => dayEl.removeClass('editing'))
        editor.setOnShowCallback(() => dayEl.addClass('editing'))
        editor.showAt(dayEl)
    }

}

export default connect(
    (state) => ({
        defaultWorkSchedules: getDefaultWorkSchedule(state),
        corporateDays: getCorporateDaysForSelectedYear(state),
        selectedYear: geSelectedYear(state),
        canManage: canManageSystemSettings(state),
    }),
    (dispatch) => ({
        addCorporateDay: bindActionCreators(addCorporateDay, dispatch),
        deleteCorporateDay: bindActionCreators(deleteCorporateDay, dispatch),
    })
)(Calendar)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/Calendar.js